import Button from 'components/Button'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import { useTheme } from 'modules/styles'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import React from 'react'

export default function ButtonPrimary (props) {
  const { children } = props
  const theme = useTheme()
  return (
    <Button
      {...props}
      isDisabled={props.isDisabled}
      url={props.url}
      type={props.type}
      onClick={props.onClick}
      style={{
        minWidth: '12em',
        textTransform: 'uppercase',
        backgroundColor: STYLES_COLOR.BLACK,
        borderRadius: theme.borderRadius.button,
        color: 'white',
        justifyContent: 'center',
        overflow: 'hidden',
        ...props.style
      }}
    >
      {
        typeof children !== 'string'
          ? children
          : (
            <TextTitleCondensed
              c='#ffffff'
              fs='18px'
              fw='760'
            >
              {children}
            </TextTitleCondensed>
            )
      }
    </Button>
  )
}
